class KontaktFormular extends HTMLElement {
  connectedCallback() {
    this.initSubmitListeners();
    this.initCloseButtonListeners();
  }

  initSubmitListeners() {
    if (this.submitButton) {
      this.submitButton.addEventListener("click", () => {
        this.handleFormSubmit();
      });
    }
    if (this.kontaktFormular) {
      this.kontaktFormular.addEventListener("submit", () => {
        this.handleFormSubmit();
      });
    }
  }

  initCloseButtonListeners() {
    const closeButtons = this.querySelectorAll('[cta="close"]');
    closeButtons.forEach(button => {
      button.addEventListener("click", (event) => {
        event.preventDefault();
        this.handleCloseSnackbar(button);
      });
    });
  }

  handleCloseSnackbar(button) {
    const snackbar = button.closest('.element-snackbar-success, .element-snackbar-warning');
    if (snackbar) {
      snackbar.removeAttribute('animate');
    }
  }

  handleFormSubmit() {
    if (this.kontaktFormular.checkValidity()) {
      this.kontaktFormular.submit();
    }
  }

  get kontaktFormular() {
    return this.querySelector(".kontakt-formular");
  }

  get submitButton() {
    return this.querySelector("[interaction=kontakt-anfrage-senden]");
  }
}

if (!customElements.get("kontakt-formular")) {
  customElements.define("kontakt-formular", KontaktFormular);
}
